export function isPeerReviewAllowed(
  assignmentMaximumGroupingSize: number | undefined
): boolean {
  return assignmentMaximumGroupingSize !== 1
}
